import { FoldersFilter } from "app/pages/segments/redesigned-wizard/segment-wizard/segment-rules-section/FoldersFilter";
import { CustomStringFilter } from "app/pages/segments/redesigned-wizard/segment-wizard/segment-rules-section/CustomStringFilter";
import { StringsFilter } from "app/pages/segments/redesigned-wizard/segment-wizard/segment-rules-section/StringsFilter";
import { ExactUrlsFilter } from "app/pages/segments/redesigned-wizard/segment-wizard/segment-rules-section/ExactUrlsFilter";

// while in our code base when we use in rulesKey "exact" and "words"
// meaning:
// exact === custom string
// words === strings
// in the UI we opposite this meaning:
// exact === when user choose words from our predicted words
// words === when user type his string
export const FILTERS_OBJECT = {
    FOLDERS: {
        filterKey: "folders",
        order: 0,
        component: FoldersFilter,
        title: "segmentWizard.editRule.folders.row.title",
    },
    EXACT: {
        filterKey: "exact",
        order: 1,
        component: CustomStringFilter,
        title: "segmentWizard.editRule.custom.string.row.title",
    },
    WORDS: {
        filterKey: "words",
        order: 2,
        component: StringsFilter,
        title: "segmentWizard.editRule.string.row.title",
    },
    EXACT_URLS: {
        filterKey: "exactURLS",
        order: 3,
        component: ExactUrlsFilter,
        title: "segmentWizard.editRule.exact.urls.row.title",
    },
};
